import React from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import LiveTooltip from 'live/components/ui/tooltip'
import { Separator } from 'plugin-smart-mobility-utils/shared/Separator/Separator'

export type PropsInformation = {
    totalStacks: number
    stacksActive: number
    percentageStacksActive: number
    stacksInactive: number
    percentageStacksInactive: number
    obcOnline: number
    percentageObcOnline: number
    obcOffline: number
    percentageObcOffline: number
}

export const KpiInformation = ({
    totalStacks,
    stacksActive,
    percentageStacksActive,
    stacksInactive,
    percentageStacksInactive,
    obcOnline,
    percentageObcOnline,
    obcOffline,
    percentageObcOffline
}: PropsInformation): JSX.Element => {
    return (
        <DivStatus>
            <DivValues>
                <TitleStatus>
                    STACKS
                    <LiveTooltip
                        className="teste"
                        content={i18n("Total number of registered stacks.")}
                        position="right"
                        onHover={true}
                    >
                        <i className={"far fa-info-circle"} > </i>
                    </LiveTooltip>
                </TitleStatus>
                <ValueStatus>
                    {
                        totalStacks
                    }
                </ValueStatus>
            </DivValues>

            <DivValues style={{gap: '24px'}}>
                <TitleStatus>
                    STACK STATUS
                    <LiveTooltip
                        className=""
                        content={i18n("Stack health status.")}
                        position="top"
                    >
                        <i className={"far fa-info-circle"} > </i>
                    </LiveTooltip>
                </TitleStatus>
                <DivInfo>
                    <PileInfo color={"#01C292"}>
                        Active
                    </PileInfo>
                    <div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                        <ValueStatus>
                            {
                                stacksActive
                            }
                        </ValueStatus>
                        <ValueInfo>
                            ({
                                percentageStacksActive
                            }%)
                        </ValueInfo>
                    </div>
                </DivInfo>
                <DivInfo>
                    <PileInfo color={"#364159"}>
                        Inactive
                    </PileInfo>
                    <div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                        <ValueStatus>
                            {
                                stacksInactive
                            }
                        </ValueStatus>
                        <ValueInfo>
                            ({
                                percentageStacksInactive
                            }%)
                        </ValueInfo>
                    </div>
                </DivInfo>

                <Separator orientation="vertical" color="var(--gray-300)" />

                <TitleStatus>
                    ONBOARD CONNECTIVITY (OBC)
                    <LiveTooltip
                        className=""
                        content={i18n("Internet connectivity status in the vehicle.")}
                        position="top"
                    >
                        <i className={"far fa-info-circle"} > </i>
                    </LiveTooltip>
                </TitleStatus>

                <DivInfo>
                    <IconStatus color={"var(--green-700)"}/>
                    <SpanStatus>
                        Online
                    </SpanStatus>
                    <div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                        <ValueStatus>
                            {
                                obcOnline
                            }
                        </ValueStatus>
                        <ValueInfo>
                            ({
                                percentageObcOnline
                            }%)
                        </ValueInfo>
                    </div>
                </DivInfo>


                <DivInfo>
                    <IconStatus color={"var(--red-500)"}/>
                    <SpanStatus>
                        Offline
                    </SpanStatus>
                    <div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                        <ValueStatus>
                            {
                                obcOffline
                            }
                        </ValueStatus>
                        <ValueInfo>
                            ({
                                percentageObcOffline
                            }%)
                        </ValueInfo>
                    </div>
                </DivInfo>

            </DivValues>
        </DivStatus>
    )
}




const DivStatus = styled.div`
	width: 100%;
    display: flex;
    justify-content: space-between;
    background: var(--gray-100);
    border: 1px solid var(--gray-300);
    border-radius: 3px;
    padding: 13px 16px;
    overflow: hidden;
`
const DivValues = styled.div`
	display: flex;
    align-items: center;
    gap: 8px;
`
const DivInfo = styled.div`
	display: flex;
    align-items: center;
    gap: 8px;
`

const TitleStatus = styled.span`
	font-family: 'SourceSansPro-SemiBold', sans-serif;
    color: var(--gray-700);
    font-size: 16px;
    font-weight: 600;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 6px;
    i {
    	font-size: 14px;
        font-weight: 400;
    	color: var(--gray-600);
    }
`

const ValueStatus = styled.span`
	font-family: SourceSansPro-Semibold;
    color: var(--gray-800);
    font-size: 18px;
    font-weight: 600;
`

const ValueInfo = styled.span`
	font-family: 'SourceSansPro-Regular', sans-serif;
    color: var(--gray-700);
    font-size: 16px;
    font-weight: 400;
    line-height: 21.6px !important;
`

const PileInfo = styled.div`
	background: ${({color}) => color};
    color: var(--gray-0);
	font-family: 'SourceSansPro-Semibold', sans-serif;
    font-size: 16px;
    width: 71px; 
    height: 19px;
    font-weight: 600;
    line-height: 120% !important;
    border: none;
    border-radius: 3px;
    padding: 0 14px;
  display: flex;
    align-items: center;
  justify-content: center;
`

const IconStatus = styled.div`
	background: ${({color}) => color};
	border-radius: 50%;
    width: 12px;
    height: 12px;
`

const SpanStatus = styled.span`
	font-family: 'SourceSansPro-SemiBold', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: var(--gray-800);
`
